//console.log('map js')

class SimplybookIndexPageMapView {

    options = {
        MAP_WIDTH: 1185,
        MAP_HEIGHT: 705,
    };

    ui = {
        mapContainer: '#sbm_map_block',
        markersContainer: '#sbm_map_block .three_last_companies',
        markerTemplate: '.marked_area'
    };

    data = [];
    markers = [];
    mapContainer = null;
    markersContainer = null;
    markerTemplate = null;
    markerStack = [];

    cacheBlockRect = {};

    timer = null;

    constructor(options) {
        this.setOptions(options);

        this.initDom();
        this.initEvents();
        this.loadData();
    }

    loadData() {
        if (!this.mapContainer || !this.mapContainer.length) {
            return;
        }

        $.getJSON(this.getParam('url'), (data) => {
            this.init(data);
        });
    }

    initEvents() {
        if ($(this.ui.mapContainer).length == 0) {
            return
        }

        var instance = this;

        $(window).resize(this.throttle(function () {
            //console.log('resize');
            instance.onResize();
        }, 500));
    }

    initDom() {
        if ($(this.ui.mapContainer).length == 0) {
            return
        }

        var instance = this;

        this.mapContainer = $(this.ui.mapContainer);
        this.markersContainer = $(this.ui.markersContainer);
        this.markerTemplate = $(this.ui.markerTemplate);
        this.markerTemplate.detach().show();
    }

    init(data) {
        var instance = this;

        this.setMapWidth();
        this.setPositioningData(data);
        this.plotData(data);
        this.cacheMarkersBounding();
        this.showNotOvMapMarkers(data, 3);
        //this.showNotOvMapMarkers(data, 3);
        this.data = data;
        this.runTimer();
    }

    runTimer() {
        var instance = this;
        clearInterval(this.timer);
        this.timer = setInterval(function () {
            if (instance.isVisible(instance.mapContainer)) {
                //console.log('vis');
                instance.showNotOvMapMarkers(instance.data, 3);
            } else {
                //console.log('not vis');
            }
        }, 1500);
    }

    stopTimer() {
        clearInterval(this.timer);
    }

    onResize() {
        this.stopTimer();
        this.setMapWidth();
        this.setPositioningData(this.data);
        this.plotMarker(this.data);
        this.plotPopup(this.data);
        this.cacheMarkersBounding();
        this.runTimer();
    }

    setMapWidth() {
        if(this.mapContainer){
            var mapWidth = this.mapContainer.outerWidth();
            var mapHeight = this.mapContainer.outerHeight();

            this.setParam('MAP_WIDTH', mapWidth);
            this.setParam('MAP_HEIGHT', mapHeight);
        }
    }

    setPositioningData(data) {
        var instance = this;

        $.each(data, function (index, item) {
            var pos = instance.corectPosition(instance.convert(parseFloat(item.lat), parseFloat(item.lng)));
            data[index]['x'] = pos[0];
            data[index]['y'] = pos[1];
        });
    }

    cacheMarkersBounding() {
        var instance = this;
        this.cacheBlockRect = {};

        $.each(this.markers, function (index, marker) {
            marker.addClass('visible').css("visibility", "hidden")
            var node = marker.find('.company_item');
            instance._getBoundingClientRect(node);
            marker.removeClass('visible').css('visibility', '');
        });
    }

    plotData(data) {
        var instance = this;

        $.each(data, function (index, item) {
            var companyUrl = data[index].company_address;

            if (!companyUrl) {
                companyUrl = 'https://' + data[index].company_login + '.simplybook.me/';
            }

            instance.markers[index] = instance.markerTemplate.clone();
            instance.markers[index].css('will-change', 'opacity, transform');
            instance.markers[index].removeClass('visible');
            instance.markers[index].find('.city_name').text(data[index].city);
            instance.markers[index].find('.country_name').text(data[index].country);
            //instance.markers[index].find('.icon').css('background-image', 'url(../../../images/icons/map-icons/' + data[index].category_key + '.png)');
            instance.markers[index].find('.icon').addClass(data[index].category_key);
            instance.markers[index].find('.link_to_booking_troll').attr('href', companyUrl);
        });

        this.markersContainer.append(this.markers);

        this.plotMarker(data);
        this.plotPopup(data);

    }

    plotMarker(data) {
        var instance = this;

        $.each(this.markers, function (index, item) {
            item.css({top: data[index]['y'], left: data[index]['x']});
        });
    }

    plotPopup(data) {
        var instance = this;
        var markerWidth = this.markers[0].find('.company_item').outerWidth();
        var mapWidth = this.getParam('MAP_WIDTH');

        $.each(this.markers, function (index, item) {
            instance._setPopupPosition(mapWidth, markerWidth, item, data[index]);
        });
    }

    showNotOvMapMarkers(data, count) {
        var instance = this;
        // var result = [];

        //instance.markerStack = [];
        instance.markerStack.shift();

        $.each(this.markers, function (index, item) {
            item.removeClass('visible');
        });

        $.each(instance.markers, function (index2, item2) {
            if (!data[index2].is_used) {
                var isOverlaps = false;

                for (var j = 0; j < instance.markerStack.length; j++) {
                    if (instance.overlaps(instance.markerStack[j].find('.company_item'), item2.find('.company_item'))) {
                        isOverlaps = true;
                    }
                }

                if (!isOverlaps) {
                    instance.markerStack.push(item2);
                }
            }

            if (instance.markerStack.length >= count) {
                return false; //break;
            }
        });

        $.each(this.markers, function (index, item) {
            //console.log(instance.markerStack.indexOf(item));
            if (instance.markerStack.indexOf(item) >= 0) {
                item.addClass('visible');
                data[index].is_used = true;
            }
        });

        //console.log(instance.overlaps(instance.markerStack[0].find('.company_item'), instance.markerStack[2].find('.company_item')));

        if (instance.markerStack.length < count) {
            this._clearUsedMarkers(data);
        }

        if (!instance.markerStack.length && data.length) {
            this.showNotOvMapMarkers(data, count);
        }
    }

    _clearUsedMarkers(data) {
        $.each(this.markers, function (index, item) {
            data[index].is_used = false;
        });
    }

    _setPopupPosition (mapWidth, markerWidth, marker, markerData) {
        var markerX = markerData['x'];
        var markerHalfWidth = markerWidth / 2;
        var markerQuarterWidth = markerWidth / 4;
        var mapHalfWidth = mapWidth / 2;

        /////LEFT MARKER POSITION
        if (markerX <= markerHalfWidth) {
            marker.addClass('in_left');
        } else if (markerX <= mapHalfWidth) {
            marker.addClass('in_middle_right');
        } else

            /////RIGHT MARKER POSITION
        if ((mapWidth - markerX) <= markerHalfWidth) {
            marker.addClass('in_right');
        } else if ((mapWidth - markerX) <= mapHalfWidth) {
            marker.addClass('in_middle_left');
        }
    }

    corectPosition(position) {
        position[0] += -39;
        position[1] = 1.08686 * position[1] + 26;
        return position;
    }

    convert(lat, lon) {
        var y = ((-1 * lat) + (180 - 85)) * (this.getParam('MAP_HEIGHT') / 180);
        var x = (lon + 180) * (this.getParam('MAP_WIDTH') / 360);
        return [x, y];
    }

    _getDivKey(div) {
        var divKey = $(div).attr('uniqkey');
        if (!divKey) {
            divKey = Math.floor(Math.random() * 10000 + Date.now());
            $(div).attr('uniqkey', divKey);
        }
        return divKey;
    }

    _getBoundingClientRect(div) {
        var divKey = this._getDivKey(div);

        /*        if(!this.cacheBlockRect[divKey]){
                    console.trace('err');
                }*/

        if (this.cacheBlockRect[divKey]) {
            return this.cacheBlockRect[divKey];
        }

        var add = 30;
        var a = div.get(0).getBoundingClientRect();

        var boundig = {
            top: a.top + add,
            left: a.left + add,
            height: a.height + add,
            width: a.width + add,
        };

        this.cacheBlockRect[divKey] = boundig;
        return boundig;
    }

    overlaps(a, b) {
        var aRect = this._getBoundingClientRect(a);
        var bRect = this._getBoundingClientRect(b);

        return !(
            ((aRect.top + aRect.height) < (bRect.top)) ||
            (aRect.top > (bRect.top + bRect.height)) ||
            ((aRect.left + aRect.width) < bRect.left) ||
            (aRect.left > (bRect.left + bRect.width))
        );
    }

    throttle(fn, delay) {
        var timer = null;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    }

    isVisible(el) {
        var elemTop = $(el).get(0).getBoundingClientRect().top;
        var elemBottom = $(el).get(0).getBoundingClientRect().bottom;

        if (!elemTop && !elemBottom) {
            return false;
        }

        // Only completely visible elements return true:
        var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
        // Partially visible elements return true:
        isVisible = elemTop < window.innerHeight && elemBottom >= 0;
        return isVisible;
    }

    /**
     * Set all options
     *
     * @param Object
     */
    setOptions(options) {
        this.options = $.extend({}, this.options, options);
    }

    /**
     * Returns param value.
     * If paramKey is not presented in this.options returns defaultValue
     *
     * @param String paramKey
     * @param mixed defaultValue
     */
    getParam(paramKey, defaultValue) {
        if ($.type(this.options[paramKey]) === 'undefined') {
            return defaultValue;
        }
        return this.options[paramKey];
    }

    /**
     * Set param value
     *
     * @param String paramKey
     * @param mixed value
     */
    setParam(paramKey, value) {
        this.options[paramKey] = value;
    }

}

global.SimplybookIndexPageMapView = SimplybookIndexPageMapView;